import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

interface ReportTile {
  label: string;
  icon: string;
  href?: string;
  disabled: boolean;
}

const TILES_PER_ROW = 3;

const renderTile = (tile: ReportTile, key: number) => {
  const card = (
    <div className="ods-status-card frontpage-card">
      <div className="ods-status-card__content">
        <span className={`ods-icon ods-icon--size-kilo ods-icon--size-echo-breakpoint-medium ${tile.icon}`} aria-hidden="true"></span>
        <span className="ods-text--size-kilo ods-text--size-echo-breakpoint-medium">{tile.label}</span>
      </div>
    </div>
  );
  return (
    <div key={key} className={tile.disabled ? "ods-grid__column--4 ods-color-text-grayscale-10" : "ods-grid__column--4"}>
      {tile.disabled || !tile.href ? card : (
        <a href={tile.href} className="o-kom-link" style={{ display: 'block' }}>{card}</a>
      )}
    </div>
  );
};

const RapporterView: React.FC<RouteComponentProps> = () => {
  const tiles: ReportTile[] = [
    { label: 'Eksamensregistrering', icon: 'ods-icon--document',           href: '/rapporter/eksamensregistrering', disabled: false },
    { label: 'Brukere',              icon: 'ods-icon--user',                                                        disabled: true  },
    { label: 'Inntekter',            icon: 'ods-icon--coin-stacks',                                                 disabled: true  },
    { label: 'Romutleie',            icon: 'ods-icon--calendar',                                                    disabled: true  },
    { label: 'Fravær',               icon: 'ods-icon--success-square',                                              disabled: true  },
    { label: 'Aktivitetslogg',       icon: 'ods-icon--message',                                                     disabled: true  },
  ];

  const sorted = [...tiles].sort((a, b) => Number(a.disabled) - Number(b.disabled));
  const rows: ReportTile[][] = [];
  for (let i = 0; i < sorted.length; i += TILES_PER_ROW) {
    rows.push(sorted.slice(i, i + TILES_PER_ROW));
  }

  return (
    <>
      <div className="ods-margin-top-25 ods-grid ods-grid--gap ods-grid--center">
        <div className="ods-grid__column--12 ods-text--align-center">
          <h2>Rapporter</h2>
        </div>
      </div>
      {rows.map((row, rowIndex) => (
        <div key={rowIndex} className="ods-grid ods-grid--gap-row-large ods-margin-top-11 ods-text--align-center">
          <div className="ods-grid__column--12">
            <div className="ods-grid ods-grid--gap ods-grid--center">
              {row.map((tile, colIndex) => renderTile(tile, rowIndex * TILES_PER_ROW + colIndex))}
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default withRouter(RapporterView);
